// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Outfit_8efbad', '__Outfit_Fallback_8efbad'","fontStyle":"normal"},"className":"__className_8efbad","variable":"__variable_8efbad"};